// BL-177 Step 3: "Edit" on a scheduled bubble. The person who scheduled it can change the text and the time while it is still scheduled.
// Templates (WhatsApp) cannot be re-worded here: only their time can change.
// BL-177 Step 2j: the edit dialog IS the Schedule send popup (Modal3D) with the message text as an extra row above the calendar.
import React, { useId, useState } from 'react';
import SchedulePanel from './SchedulePanel';

export default function ScheduledEditDialog({ row, now, recipientTimeZone, busy = false, error = '', onSave, onClose }) {
    const id = useId();
    const isTemplate = Boolean(row?.content_sid);
    const [body, setBody] = useState(row?.body || '');
    return (
        <SchedulePanel
            title="Edit scheduled message"
            subtitle="Change the text or the time."
            confirmLabel="Save changes"
            now={now}
            companyTimeZone={row?.company_time_zone || 'America/New_York'}
            recipientTimeZone={recipientTimeZone}
            initialAt={row?.scheduled_for}
            initialCancelOnReply={row?.cancel_on_reply}
            busy={busy}
            error={error}
            modalProps={{ 'data-scheduled-edit': 'true' }}
            onClose={onClose}
            onConfirm={({ at, cancelOnReply }) => onSave?.({ body: isTemplate ? undefined : body, at, cancelOnReply })}
        >
            <label htmlFor={`${id}-body`} className="flex flex-col gap-1 text-sm font-bold">
                Message
                <textarea
                    id={`${id}-body`}
                    value={body}
                    disabled={isTemplate}
                    onChange={(event) => setBody(event.target.value)}
                    rows={4}
                    className="w-full resize-y rounded-lg border border-[#3B4D73] bg-[#0B1220] p-2 text-sm font-normal text-white disabled:opacity-70"
                />
                {isTemplate && <span className="text-xs font-normal">This is an approved template, so only the time can change.</span>}
            </label>
        </SchedulePanel>
    );
}
